import React from 'react';
import Offline from '../../../components/Errors/Offline';

const OfflinePage = () => {
  return <Offline />;
};

export default OfflinePage;
